.root {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  /* Не #fff, хотя в макете именно он: осознанное отступление ради контраста в тёмной теме.
     Обоснование и цифры — в UserAvatar.module.css. */
  color: var(--on-accent);
  font-weight: 600;
}

.sm {
  width: 24px;
  height: 24px;
  border-radius: 5px;
  font-size: 11px;
}

.md {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 12px;
}
